export default class UserProductGroupParent {
	id: string;

	name: string;

	productGroupsCount: number;

	constructor(id: string, name: string, productGroupsCount: number) {
		this.id = id;
		this.name = name;
		this.productGroupsCount = productGroupsCount;
	}
}
